const MAX_FILE_SIZE_IN_MB = 10;
const MAX_FILE_SIZE_IN_BYTES = MAX_FILE_SIZE_IN_MB * 1024 * 1024;

const isFileSizeExceeded = function (file: File, sizeInBytes?: number) {
  const maxFileSize = sizeInBytes || MAX_FILE_SIZE_IN_BYTES;
  return parseFloat(file.size.toFixed(2)) > maxFileSize;
};

export { MAX_FILE_SIZE_IN_BYTES, MAX_FILE_SIZE_IN_MB, isFileSizeExceeded };
